import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { concatMap, from, map } from 'rxjs';
import { ServiciosService } from 'src/app/services/inventario/servicios.service';
import { DoctoresService } from 'src/app/services/personas/doctores.service';
import { OrdenesService } from 'src/app/services/transacciones/ordenes.service'
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-subir-imagenes-periapical',
    templateUrl: './subir-imagenes-periapical.component.html',
    styleUrls: ['./subir-imagenes-periapical.component.scss'],
    standalone: false
})

export class SubirImagenesPeriapicalComponent implements OnInit {

  
  public nombrePaciente:string = "";
  public nombreDoctor: string = "";
  detalleOrden: any[] = [];
  public metodosPagos:string = "Efectivo";
  public talonarioDocotor:string = "";
  detalleOrdenNew: any[] = [];  
  public idOrden: string = "";
  public spinnerBoolean: boolean = false;
  public cargando: string = "Obteniendo información por favor espere....";
  public txtOrdenFisica: string = "";
  public numeroOrden: string = ""
  public imageContainer = document.getElementById('image-container');
   //ngx-dropzone
	 private baseSistema: string = environment.systemLegacyUrl;
   constructor(

    public route: ActivatedRoute,
    public router: Router,
    private ordenesService: OrdenesService,
    private serviciosService: ServiciosService,
    private doctoresService: DoctoresService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {

    var idOrden = this.route.snapshot.paramMap.get('id')!.toString().substring(100,this.route.snapshot.paramMap.get('id')!.toString().length-100);
    this.idOrden = idOrden;
    this.spinnerBoolean = true;
    /* -------------------------------------------------------------------------- */
    /*                          OBTENER DATOS DE LA ORDEN                         */
    /* -------------------------------------------------------------------------- */
    this.ordenesService.mostrarOrdenesNormal(localStorage.getItem('token'),"normal","COD_ORD", idOrden).subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp.rows));
      this.nombrePaciente = content[0].NOM_CLI;
      this.nombreDoctor = content[0].NOM_DOC;
    
      this.numeroOrden = content[0].NUM_ORD
        /* -------------------------------------------------------------------------- */
      /*                              DATOS DEL DOCTOR                              */
      /* -------------------------------------------------------------------------- */
      this.doctoresService.mostrarDoctoresNormal(localStorage.getItem('token'),"CodVendedor", content[0].CODN_DOC).subscribe((resp) => {
        this.talonarioDocotor = content[0].Abreviatura;

      });

      var preciosSelect :any[] = [];

       /* -------------------------------------------------------------------------- */
       /*                             DETALLE DE LA ORDEN                            */
       /* -------------------------------------------------------------------------- */

      
      
        var content = JSON.parse(content[0].DET_ORD);
        content.forEach((currentValue, index) => {
        
          preciosSelect.push({
           
            "precio" :  currentValue.precio1,


            },{

              "precio" :currentValue.precio2,


          },{

              "precio" :  currentValue.precio3,


          },{

            "precio" :currentValue.precio4,


          });

          if (
            currentValue.tipo ==
            'LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)'
          ) {
            this.detalleOrden.push({
              id: currentValue.id,
                posicionDetalle: index,

              producto: currentValue.producto,
              codigo: currentValue.codigo,
              valor: currentValue.valor,
              pieza: currentValue.pieza,
              agregado: ' ',
              precio1: currentValue.precio1,
              precio2: currentValue.precio2,
              precio3: currentValue.precio3,
              precio4: currentValue.precio4,
              impuesto: currentValue.impuesto,
              incluidoIva: currentValue.incluidoIva,
              precioSeleccionado: currentValue.precioSeleccionado,
              tipo: currentValue.tipo,
              preciosSelect: preciosSelect,
              imagenes: [],
              imagenesBase: [],
              videos: [],
              videosBase: [],
              documentos: [],
              documentosBase: [],
              imagenesSubidas: currentValue.imagenesSubidas
                ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
                : [],
              documentosSubidos: currentValue.documentosSubidos
                ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
                : [],
              videosSubidos: currentValue.videosSubido
                ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
                : [],
              tipoSubida: 'LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)',
            });
          }

          if (currentValue.tipo == 'ECOGRAFIA'  ||  currentValue.tipo == 'ECOGRAFIAS ESPECIALES') {
            this.detalleOrden.push({
              id: currentValue.id,
                posicionDetalle: index,

              producto: currentValue.producto,
              codigo: currentValue.codigo,
              valor: currentValue.valor,
              pieza: currentValue.pieza,
              agregado: ' ',
              precio1: currentValue.precio1,
              precio2: currentValue.precio2,
              precio3: currentValue.precio3,
              precio4: currentValue.precio4,
              impuesto: currentValue.impuesto,
              incluidoIva: currentValue.incluidoIva,
              precioSeleccionado: currentValue.precioSeleccionado,
              tipo: currentValue.tipo,
              preciosSelect: preciosSelect,
              imagenes: [],
              imagenesBase: [],
              videos: [],
              videosBase: [],
              documentos: [],
              documentosBase: [],
              imagenesSubidas: currentValue.imagenesSubidas
                ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
                : [],
              documentosSubidos: currentValue.documentosSubidos
                ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
                : [],
              videosSubidos: currentValue.videosSubido
                ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
                : [],
              tipoSubida: 'ECOGRAFIA',
              enviado: currentValue.enviado ? currentValue.enviado : '',
              facturacion: currentValue.facturacion
                ? currentValue.facturacion
                : '',
            });
          }

          if (
            currentValue.tipo == 'TOMOGRAFIA 3D' ||
            currentValue.tipo == 'TOMOGRAFIA 3D (MATRIZ)' 
          ) {
            this.detalleOrden.push({
              id: currentValue.id,
                posicionDetalle: index,

              producto: currentValue.producto,
              codigo: currentValue.codigo,
              valor: currentValue.valor,
              pieza: currentValue.pieza,
              agregado: ' ',
              precio1: currentValue.precio1,
              precio2: currentValue.precio2,
              precio3: currentValue.precio3,
              precio4: currentValue.precio4,
              impuesto: currentValue.impuesto,
              incluidoIva: currentValue.incluidoIva,
              precioSeleccionado: currentValue.precioSeleccionado,
              tipo: currentValue.tipo,
              preciosSelect: preciosSelect,
              imagenes: [],
              imagenesBase: [],
              videos: [],
              videosBase: [],
              documentos: [],
              documentosBase: [],
              imagenesSubidas: currentValue.imagenesSubidas
                ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
                : [],
              documentosSubidos: currentValue.documentosSubidos
                ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
                : [],
              videosSubidos: currentValue.videosSubido
                ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
                : [],
              tipoSubida: 'TOMOGRAFIA 3D',
              enviado: currentValue.enviado ? currentValue.enviado : '',
              facturacion: currentValue.facturacion
                ? currentValue.facturacion
                : '',
            });
          }

          if (
            currentValue.codigo == 'PERIAP-PLUS' ||
            currentValue.codigo == 'PERIAPICAL' ||
            currentValue.codigo == 'SERIE 002' ||
            currentValue.codigo == 'PERIAP-PLUS-FISCIO'
          ) {
            this.detalleOrden.push({
              id: currentValue.id,
                posicionDetalle: index,

              producto: currentValue.producto,
              codigo: currentValue.codigo,
              valor: currentValue.valor,
              pieza: currentValue.pieza,
              agregado: ' ',
              precio1: currentValue.precio1,
              precio2: currentValue.precio2,
              precio3: currentValue.precio3,
              precio4: currentValue.precio4,
              impuesto: currentValue.impuesto,
              incluidoIva: currentValue.incluidoIva,
              precioSeleccionado: currentValue.precioSeleccionado,
              tipo: currentValue.tipo,
              preciosSelect: preciosSelect,
              imagenes: [],
              imagenesBase: [],
              videos: [],
              videosBase: [],
              documentos: [],
              documentosBase: [],
              imagenesSubidas: currentValue.imagenesSubidas
                ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
                : [],
              documentosSubidos: currentValue.documentosSubidos
                ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
                : [],
              videosSubidos: currentValue.videosSubido
                ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
                : [],
              tipoSubida: 'PERIAPICAL',
              enviado: currentValue.enviado ? currentValue.enviado : '',
              facturacion: currentValue.facturacion
                ? currentValue.facturacion
                : '',
                images : []
            });
          }

          if (
            currentValue.codigo == 'PANO 001' ||
            currentValue.codigo=="PANO 002" ||
            currentValue.codigo == 'A.T.M.' ||
            currentValue.codigo == 'PANO PLUS' ||
            currentValue.codigo == 'LATE 001' ||
            currentValue.codigo == 'RX-CARPAL' ||
             currentValue.codigo=="SENOS 001" ||
             currentValue.codigo == 'PANO 002' ||
             currentValue.codigo=="ANTEROPOSTERIOR"
          ) {
            this.detalleOrden.push({
              id: currentValue.id,
                posicionDetalle: index,

              producto: currentValue.producto,
              codigo: currentValue.codigo,
              valor: currentValue.valor,
              pieza: currentValue.pieza,
              agregado: ' ',
              precio1: currentValue.precio1,
              precio2: currentValue.precio2,
              precio3: currentValue.precio3,
              precio4: currentValue.precio4,
              impuesto: currentValue.impuesto,
              incluidoIva: currentValue.incluidoIva,
              precioSeleccionado: currentValue.precioSeleccionado,
              tipo: currentValue.tipo,
              preciosSelect: preciosSelect,
              imagenes: [],
              imagenesBase: [],
              videos: [],
              videosBase: [],
              documentos: [],
              documentosBase: [],
              imagenesSubidas: currentValue.imagenesSubidas
                ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
                : [],
              documentosSubidos: currentValue.documentosSubidos
                ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
                : [],
              videosSubidos: currentValue.videosSubido
                ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
                : [],
              tipoSubida: 'PANORAMICA',
              enviado: currentValue.enviado ? currentValue.enviado : '',
              facturacion: currentValue.facturacion
                ? currentValue.facturacion
                : '',
            });
          }

          if (currentValue.tipo == 'BAZAR' || currentValue.tipo == 'FARMACIA') {
            this.detalleOrden.push({
              id: currentValue.id,
                posicionDetalle: index,

              producto: currentValue.producto,
              codigo: currentValue.codigo,
              valor: currentValue.valor,
              pieza: currentValue.pieza,
              agregado: ' ',
              precio1: currentValue.precio1,
              precio2: currentValue.precio2,
              precio3: currentValue.precio3,
              precio4: currentValue.precio4,
              impuesto: currentValue.impuesto,
              incluidoIva: currentValue.incluidoIva,
              precioSeleccionado: currentValue.precioSeleccionado,
              tipo: currentValue.tipo,
              preciosSelect: preciosSelect,
              imagenes: [],
              imagenesBase: [],
              videos: [],
              videosBase: [],
              documentos: [],
              documentosBase: [],
              imagenesSubidas: currentValue.imagenesSubidas
                ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
                : [],
              documentosSubidos: currentValue.documentosSubidos
                ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
                : [],
              videosSubidos: currentValue.videosSubido
                ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
                : [],
              tipoSubida: 'BAZAR',
              enviado: currentValue.enviado ? currentValue.enviado : '',
              facturacion: currentValue.facturacion
                ? currentValue.facturacion
                : '',
            });
          }

          if (currentValue.tipo == 'INYECTOLOGIA') {
            this.detalleOrden.push({
              id: currentValue.id,
                posicionDetalle: index,

              producto: currentValue.producto,
              codigo: currentValue.codigo,
              valor: currentValue.valor,
              pieza: currentValue.pieza,
              agregado: ' ',
              precio1: currentValue.precio1,
              precio2: currentValue.precio2,
              precio3: currentValue.precio3,
              precio4: currentValue.precio4,
              impuesto: currentValue.impuesto,
              incluidoIva: currentValue.incluidoIva,
              precioSeleccionado: currentValue.precioSeleccionado,
              tipo: currentValue.tipo,
              preciosSelect: preciosSelect,
              imagenes: [],
              imagenesBase: [],
              videos: [],
              videosBase: [],
              documentos: [],
              documentosBase: [],
              imagenesSubidas: currentValue.imagenesSubidas
                ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
                : [],
              documentosSubidos: currentValue.documentosSubidos
                ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
                : [],
              videosSubidos: currentValue.videosSubido
                ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
                : [],
              tipoSubida: 'INYECTOLOGIA',
              enviado: currentValue.enviado ? currentValue.enviado : '',
              facturacion: currentValue.facturacion
                ? currentValue.facturacion
                : '',
            });
          }

          if (currentValue.tipo == 'SUEROTERAPIA') {
            this.detalleOrden.push({
              id: currentValue.id,
                posicionDetalle: index,

              producto: currentValue.producto,
              codigo: currentValue.codigo,
              valor: currentValue.valor,
              pieza: currentValue.pieza,
              agregado: ' ',
              precio1: currentValue.precio1,
              precio2: currentValue.precio2,
              precio3: currentValue.precio3,
              precio4: currentValue.precio4,
              impuesto: currentValue.impuesto,
              incluidoIva: currentValue.incluidoIva,
              precioSeleccionado: currentValue.precioSeleccionado,
              tipo: currentValue.tipo,
              preciosSelect: preciosSelect,
              imagenes: [],
              imagenesBase: [],
              videos: [],
              videosBase: [],
              documentos: [],
              documentosBase: [],
              imagenesSubidas: currentValue.imagenesSubidas
                ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
                : [],
              documentosSubidos: currentValue.documentosSubidos
                ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
                : [],
              videosSubidos: currentValue.videosSubido
                ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
                : [],
              tipoSubida: 'SUEROTERAPIA',
              enviado: currentValue.enviado ? currentValue.enviado : '',
              facturacion: currentValue.facturacion
                ? currentValue.facturacion
                : '',
            });
          }
          
         
  if (currentValue.tipo == 'RADIOGRAFIAS CORPORAL') {
          this.detalleOrden.push({
            id: currentValue.id,
              posicionDetalle: index,

            producto: currentValue.producto,
            codigo: currentValue.codigo,
            valor: currentValue.valor,
            pieza: currentValue.pieza,
            agregado: ' ',
            precio1: currentValue.precio1,
            precio2: currentValue.precio2,
            precio3: currentValue.precio3,
            precio4: currentValue.precio4,
            impuesto: currentValue.impuesto,
            incluidoIva: currentValue.incluidoIva,
            precioSeleccionado: currentValue.precioSeleccionado,
            tipo: currentValue.tipo,
            preciosSelect: preciosSelect,
            imagenes: [],
            imagenesBase: [],
            videos: [],
            videosBase: [],
            documentos: [],
            documentosBase: [],
            imagenesSubidas: currentValue.imagenesSubidas
              ? JSON.parse(JSON.stringify(currentValue.imagenesSubidas))
              : [],
            documentosSubidos: currentValue.documentosSubidos
              ? JSON.parse(JSON.stringify(currentValue.documentosSubidos))
              : [],
            videosSubidos: currentValue.videosSubido
              ? JSON.parse(JSON.stringify(currentValue.videosSubidos))
              : [],
            tipoSubida: 'RADIOGRAFIAS CORPORAL',
            enviado: currentValue.enviado ? currentValue.enviado : '',
            facturacion: currentValue.facturacion
              ? currentValue.facturacion
              : '',
          });
        }
        });
       
        this.detalleOrden.forEach((orden, i) => {
          orden.imagenesSubidas.forEach(imagen => {
            if(imagen.guardadoServidor){
              imagen.imagen = this.baseSistema + "/radiografia/vistas/img/multimedia/"+ imagen.imagen;
            }else{
              //obtiene del drive y guarda en el servidor
              this.getUrL(imagen); 
            }
            // Llama a getUrL para cada imagen
          });
        });
       
       
       this.spinnerBoolean = false;
    });

  }


  
  /* -------------------------------------------------------------------------- */
  /*                                 PRECIO ITEM                                */
  /* -------------------------------------------------------------------------- */
  precioItem(codigo,precio1:any, precio2, precio3, precio4, derivado, tipo, precioLab, preciosDerivados){

    if(precioLab!="" && tipo=="LABORATORIO (MATRIZ - ALBORADA - PORTETE - DURAN)"){

      if(precioLab=="A"){

        precio1 = precio1;
       
      }

      if(precioLab=="B"){

        precio1 =  precio2 == ""  ? precio1 : precio2;

      
      }

      if(precioLab=="C"){

        precio1 = precio3 == ""  ? precio1 :precio3 ;
      
      }
      if(precioLab=="D"){

       precio1 = precio4  == ""  ? precio1 : precio4 ;
       
      }


  }else{

  
    if(precio1==""){
      
      precio1 = this.talonarioDocotor;
  
      
    }

  }

  var precioDerivado = "";
  
  if(derivado=="1"){

    var content = JSON.parse(preciosDerivados);
    $.each(content, function(id, name) {


      precioDerivado = name.precio;


  });
      
  }
  

 
  if(Number(precio2)<Number(precioDerivado)){
      
      precio2 = "";
  }
  
  if(Number(precio3)<Number(precioDerivado)){
      
      precio3 = "";
  }
  
    if(Number(precio4)<Number(precioDerivado)){
      
      precio4 = "";
  }


  if(this.metodosPagos!="EFECTIVO" && this.metodosPagos!=""){
                
   
    precio1 = (precio1*1.06);
    precio1 = parseFloat(precio1).toFixed(2)

    precio2 = (precio2 == "" ? 0 : precio2 *1.06);
    precio2 = parseFloat(precio2).toFixed(2)

    precio3 = (precio3 == "" ? 0 : precio3*1.06);
    precio3 = parseFloat(precio3).toFixed(2)

    precio4 = (precio4 == "" ? 0 : precio4 *1.06);
    precio4 = parseFloat(precio4).toFixed(2)
  
  
  }
   


    return precio1+","+precio2+","+precio3+","+precio4;
  }


  /* -------------------------------------------------------------------------- */
  /*                         SELECCIONAR IMAGEN DROPZONE                        */
  /* -------------------------------------------------------------------------- */
  onSelect(event: any, files, filesBase) {

    files.push(...event.addedFiles);
  }
  


  /* -------------------------------------------------------------------------- */
  /*                           REMOVER IMAGEN DROPZONE                          */
  /* -------------------------------------------------------------------------- */
  onRemove(event: any,files, filesBase) {
    files.splice(files.indexOf(event), 1);

 
  }	


  /* -------------------------------------------------------------------------- */
  /*                               SUBIR IMAGENES                               */
  /* -------------------------------------------------------------------------- */
 
  /* -------------------------------------------------------------------------- */
  /*                               SUBIR IMAGENES                               */
  /* -------------------------------------------------------------------------- */
  async subirImagenes(){

    var bandera = true;
    await this.imgBase();
    this.cargando = "Subiendo imágenes a la nube C&M por favor espere...."
    this.spinnerBoolean = true;
    setTimeout(() => {
      
      this.detalleOrden.forEach((currentValue, index) => {
   
      var content = JSON.parse(JSON.stringify(currentValue.imagenesBase));
      
      if(content.length<=0   && currentValue.imagenesSubidas.length<=0 ){

        if(currentValue.codigo == "PERIAP-PLUS" ||  currentValue.codigo == "PERIAPICAL"  ||  currentValue.codigo == "SERIE 002"){
          this.toastr.info("Suba al menos una imagen en el servicio "+ currentValue.producto, 'Atención', {
            timeOut: 5000,
            closeButton: true,
            progressBar: true
          });
          
          bandera = false;
          this.spinnerBoolean = true;
          return;

        }

     
      } 
      });
     
      
      if(bandera){

     
      this.ordenesService.cargarImagenesPorDeptamento(
        
        this.idOrden,
        this.txtOrdenFisica,
        JSON.stringify(this.detalleOrden),
        localStorage.getItem('token'),
        "PERIAPICAL"
       
      ).subscribe((resp) => {
  
        this.spinnerBoolean = false;
        if(resp){
          this.toastr.success("Multimedia actualizada correctamente y subida a la nube C&M", 'Atención', {
            timeOut: 7000,
            closeButton: true,
            progressBar: true
          });
          this.router.navigateByUrl('sistema/periapical');
        }else{

        

          this.toastr.success("Multimedia actualizada correctamente y subida a la nube C&M", 'Atención', {
            timeOut: 7000,
            closeButton: true,
            progressBar: true
          });
          this.router.navigateByUrl('sistema/panoramica');
            
          
        }
     
  
      });
    }
      
     
   
   },5000);
    

   

    
  
 
  }


  /* -------------------------------------------------------------------------- */
  /*                           VOLVER A LISTA ORDENES                           */
  /* -------------------------------------------------------------------------- */
  volverAtras(){

    this.router.navigateByUrl('sistema/periapical');

  }


  /* -------------------------------------------------------------------------- */
  /*                                SUBIR VIDEOS                                */
  /* -------------------------------------------------------------------------- */
  subirDocumentos(event, documentos, documentosBase){

    if(event.target.files[0]["type"] == "image/jpeg" || event.target.files[0]["type"] == "image/png"){

      this.toastr.error('El formado no es de tipo documento', 'Atención', {
        timeOut: 9000,
        closeButton: true,
        progressBar: true
      });

      event.target.value = "";

      return;
    }

    documentos.push(event.target.files[0]);
  
    for(var i = 0; i < documentos.length; i++) {

      const file = documentos[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {

        if(documentos.length <=1){

          documentosBase.push({
  
            "documentos" : reader.result
          })
        }

        for(var j = 0; j < documentosBase.length; j++) {

            if(reader.result !== documentosBase[j].documentos){
              documentosBase.push({
  
                "documentos" : reader.result
              })
  
            }
          

       

        
        }
     
        
         
      };

    }

    
  }
  

  /* -------------------------------------------------------------------------- */
  /*                              SUBIR DOCUMENTOS                              */
  /* -------------------------------------------------------------------------- */
  subirVideos(event, videos, videosBase){
    videos.push(event.target.files[0]);
    for(var i = 0; i < videos.length; i++) {

      const file = videos[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if(!videosBase.includes(reader.result)){
          videosBase.push({

            "videos" : reader.result
          })
        }        
      };

    }
  
  }


  /* -------------------------------------------------------------------------- */
  /*                                ORDEN FISICA                                */
  /* -------------------------------------------------------------------------- */
  ordenFisica(event){

    const file =  event.target.files[0]
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
    

    this.txtOrdenFisica = reader.result as string;
      
    };        
  }


  /* -------------------------------------------------------------------------- */
  /*                          ELIMINAR ITEMS DOCUMENOS                          */
  /* -------------------------------------------------------------------------- */
  borrarItem(array, index){

    array.splice(index, 1);

  }

  borrarItemSI(array, index,detalleImagen){

    array.splice(index, 1);
    detalleImagen.splice(index, 1);

  }
  
  imgBase(){

    /*this.detalleOrden.map((item) => {
     
      item.imagenes.map((item1) => {
        const file = item1;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {


         
         
         await item.imagenesBase.push({
  
              "imagenes" : reader.result
            })
               
        };
  
      });
    });*/
   
    
  }




  //images: string[] = [];

  /*onPaste(event: ClipboardEvent) {
    const items = event.clipboardData?.items;
    if (items) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const blob = items[i].getAsFile();
          const imageUrl = URL.createObjectURL(blob!);
          this.images.push(imageUrl);
        }
      }
    }
  }*/

  onPaste(event: ClipboardEvent, detalleImagenes, images) {
    const items = event.clipboardData?.items;
    if (items) {
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const blob = items[i].getAsFile();
          const imageUrl = URL.createObjectURL(blob!);
          images.push(imageUrl);
          const file = imageUrl;
          const reader = new FileReader();
          reader.readAsDataURL(blob!);
          reader.onload = async () => {
  
  
           
           
            detalleImagenes.push({
    
                "imagenes" : reader.result
              })

              console.log(detalleImagenes);
                 
          };
        }
      }
    }

    
  
}

getUrL(img: any) {
  this.ordenesService.getImageServer(img.imagen, localStorage.getItem('token'))
    .subscribe((resp) => {
      img.imagen = resp; // Actualiza la propiedad 'url' del objeto de imagen
      img.guardadoServidor = true;
    });
}

verContenidoVideo(objetoVideo, event:MouseEvent){
  event.preventDefault();
  if(objetoVideo.guardadoServidor){
    window.open(this.baseSistema + "/radiografia/vistas/img/multimedia/"+ objetoVideo.videos,"_blank");
  }else{
      window.open(`http://drive.google.com/uc?export=view&id=${objetoVideo.videos}`,"_blank")
  }
}

verContenidoDocumentos(objetoDocumento, event:MouseEvent){
  event.preventDefault();
  if(objetoDocumento.guardadoServidor){
    window.open(this.baseSistema + "/radiografia/vistas/img/multimedia/"+ objetoDocumento.documentos,"_blank");
  }else{
      window.open(`http://drive.google.com/uc?export=view&id=${objetoDocumento.documentos}`,"_blank")
  }
}



}
@Pipe({
    name: 'safeUrl',
    standalone: false
})
export class SafeUrlPipe implements PipeTransform {

  constructor(private domSanitizer: DomSanitizer) {}

  transform(value: any, args?: any): any {
    return this.domSanitizer.bypassSecurityTrustUrl(value);
  }

}
